exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#kollus_player_cont[data-v-76aba308] {\n    width: 100%;\n    height: 100%;\n}\n.notify-window[data-v-76aba308] {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n", ""]);

// exports
